import { Toolbar } from "@mui/x-data-grid";
import {
  TextField,
  MenuItem,
  Box,
  IconButton,
  Typography,
  //Toolbar,
} from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

function CustomToolbar({
  paginationModel,
  setPaginationModel,
  totalRowCount,
  searchQuery,
  SearchInvoices,
}) {
  const pageSizes = [5, 10, 20, 50, 100, 200, 500, 1000];

  const totalPages = Math.ceil(totalRowCount / paginationModel.pageSize);

  const handleChangePageSize = (e) => {
    const newSize = Number(e.target.value);

    const newPagination = {
      page: 0, // reset về trang đầu
      pageSize: newSize,
    };

    setPaginationModel(newPagination);
    SearchInvoices(searchQuery, newPagination);
  };

  const goToPage = (newPage) => {
    const newPagination = {
      ...paginationModel,
      page: newPage,
    };
    setPaginationModel(newPagination);
    SearchInvoices(searchQuery, newPagination);
  };

  return (
    <Toolbar
      sx={{
        p: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {/* Điều khiển số trang */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton
            color="primary"
            disabled={paginationModel.page === 0}
            onClick={() => goToPage(paginationModel.page - 1)}
          >
            <NavigateBeforeIcon />
          </IconButton>

          <Box sx={{ fontWeight: "bold" }}>
            Trang {paginationModel.page + 1} / {totalPages || 1}
          </Box>

          <IconButton
            color="primary"
            disabled={paginationModel.page + 1 >= totalPages}
            onClick={() => goToPage(paginationModel.page + 1)}
          >
            <NavigateNextIcon />
          </IconButton>
        </Box>
        {/* Chọn số dòng */}
        <Typography>Số dòng mỗi trang:</Typography>
        <TextField
          select
          size="small"
          value={paginationModel.pageSize}
          onChange={handleChangePageSize}
          sx={{ width: 120 }}
        >
          {pageSizes.map((size) => (
            <MenuItem value={size} key={size}>
              {size}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Typography sx={{ fontSize: 14 }}>
        Tổng số <strong>{totalRowCount}</strong> kết quả trong{" "}
        <strong>{totalPages}</strong> trang
      </Typography>
    </Toolbar>
  );
}

export default CustomToolbar;
